import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import setStaticFolderScopeId from '../actions/setStaticFolderScopeId';
import { getStore as getSearchStore } from '../store/Store';
import { mutator } from 'satcheljs';

/**
 * Mutator which will set FolderId and folder Display name in search store
 */
export default mutator(
    setStaticFolderScopeId,
    function setStaticFolderScopeIdMutator({
        folderId,
        isAllFolder,
    }: {
        folderId: string;
        isAllFolder: boolean;
    }) {
        const searchStore = getSearchStore();
        /**
         * selected folder is 'All folder' only if
         * 1. First search from inbox 'or'
         * 2. All folder is selected
         */
        if (
            (isAllFolder && folderId === folderNameToId('inbox')) ||
            folderId === folderNameToId('msgfolderroot')
        ) {
            searchStore.staticFolderScopeId = folderNameToId('msgfolderroot');
        } else {
            searchStore.staticFolderScopeId = folderId;
        }
    }
);
